import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetDocumentsBuildings_buildingIdDocuments_documentIdDownload = z.any()
export type TagsGetDocumentsBuildings_buildingIdDocuments_documentIdDownload = z.infer<typeof tagsGetDocumentsBuildings_buildingIdDocuments_documentIdDownload>

export const descriptionGetDocumentsBuildings_buildingIdDocuments_documentIdDownload = z.any()
export type DescriptionGetDocumentsBuildings_buildingIdDocuments_documentIdDownload = z.infer<typeof descriptionGetDocumentsBuildings_buildingIdDocuments_documentIdDownload>

export const paramsGetDocumentsBuildings_buildingIdDocuments_documentIdDownload = z.object({ "buildingId": z.string().uuid(), "documentId": z.string().uuid() })
export type ParamsGetDocumentsBuildings_buildingIdDocuments_documentIdDownload = z.infer<typeof paramsGetDocumentsBuildings_buildingIdDocuments_documentIdDownload>

export const responseGetDocumentsBuildings_buildingIdDocuments_documentIdDownload = z.any()
export type ResponseGetDocumentsBuildings_buildingIdDocuments_documentIdDownload = z.infer<typeof responseGetDocumentsBuildings_buildingIdDocuments_documentIdDownload>

interface IGetDocumentsBuildings_buildingIdDocuments_documentIdDownload extends BaseMethodType {
  tags: TagsGetDocumentsBuildings_buildingIdDocuments_documentIdDownload,
  description: DescriptionGetDocumentsBuildings_buildingIdDocuments_documentIdDownload,
  params: ParamsGetDocumentsBuildings_buildingIdDocuments_documentIdDownload,
  response: ResponseGetDocumentsBuildings_buildingIdDocuments_documentIdDownload
}
export const URL = '/documents/buildings/:buildingId/documents/:documentId/download'
export const validation = {
  get: {
    tags: tagsGetDocumentsBuildings_buildingIdDocuments_documentIdDownload,
    description: descriptionGetDocumentsBuildings_buildingIdDocuments_documentIdDownload,
    params: paramsGetDocumentsBuildings_buildingIdDocuments_documentIdDownload,
    response: responseGetDocumentsBuildings_buildingIdDocuments_documentIdDownload
  }
}
export interface DocumentsBuildings_buildingIdDocuments_documentIdDownload extends BaseRouteType {
  get: IGetDocumentsBuildings_buildingIdDocuments_documentIdDownload
}